import { useMemo } from 'react'
import { useAuth } from '../context/AuthContext'
import { dostepFunkcji, wyliczPlan } from '../lib/plany'

/**
 * Plan konta (FE-01): `{ stan, plan, proba, dniProby, funkcje, limitKont, … }`, opis stanów w lib/plany.js.
 *
 * Nie mylić z `useAuth().moze(klucz)`: to uprawnienia osoby w zespole firmy (np. `wycena`), a tu funkcje planu
 * firmy (np. `projekt3d`). Jedno i drugie może zasłonić ten sam przycisk z innego powodu.
 */
export const usePlan = () => {
  const { isAuthenticated, loading, profilUstalany, profil } = useAuth()
  return useMemo(
    () => wyliczPlan({ zalogowany: isAuthenticated, ustalanie: Boolean(loading || profilUstalany), profil }),
    [isAuthenticated, loading, profilUstalany, profil],
  )
}

/**
 * Czy wolno użyć funkcji Premium: `{ mozna, ustalanie, powod }`, `powod` to `bez_konta` albo `premium`.
 * Przykład: `const { mozna } = useMozna('projekt3d')`. Klucze w config/plany.js (`FUNKCJE_PREMIUM`).
 */
export const useMozna = (funkcja) => {
  const plan = usePlan()
  return useMemo(() => dostepFunkcji(plan, funkcja), [plan, funkcja])
}

export default usePlan
